import { Camera } from 'lucide-react';
import { formatNumberDisplay } from '../../../../../utils/utils';

const PHOTO_CATEGORY_ORDER = ['Master', 'Exterior', 'Living1', 'Kitchen1', 'Bathroom1', 'Bedroom1', 'Plans', 'Unsorted'];

const getFirstPhotoUrl = photos => {
  if (!photos) return null;
  for (const category of PHOTO_CATEGORY_ORDER) {
    const url = photos[category]?.[0]?.image;
    if (url) return url;
  }
  return null;
};

export const SearchItem = ({ item, handleItemClick = () => {} }) => {
  const { location, tariff, photo } = item;
  const { id, location_city_id } = location;
  const tariff_price = tariff?.tariff_price;
  const photoUrl = getFirstPhotoUrl(photo?.photos);

  return (
    <div
      onClick={() => handleItemClick(item.id)}
      className="w-64 min-h-11 flex p-1 items-center hover:bg-gray-100 cursor-pointer sm:w-[348px]"
    >
      <div className="mr-4 h-full w-14 flex items-center justify-center">
        {photoUrl ? (
          <img
            alt="img"
            src={photoUrl}
            className="block w-full h-full object-cover object-center"
          />
        ) : (
          <Camera size={14} />
        )}
      </div>

      <div className="flex flex-col justify-between">
        <div className="text-xs">{item.id}</div>

        <div className="text-xs text-gray-500">
          <span className="mr-2">{`${location_city_id?.name ? location_city_id.name : ''}${tariff_price ? `, ${formatNumberDisplay(tariff_price)} €` : ''}`}</span>
        </div>
      </div>
    </div>
  );
};
